import React, { useContext } from 'react';
import PropTypes from 'prop-types';

import { Box, Button, Stack, Typography } from '@mui/material';

import Axios from '../../../Assets/Axios/Axios';

import ToastContext from '../../../Context/ToastContext';

import { COLORS } from '../../../Constant/COLORS';
import { ORDER_STATUS } from '../../../Constant/Enums';

import CardLayout from '../../../Components/CardLayout';
import { TypoPoppBlue, TypoPoppins } from '../../../Components/Typo';

import { UpdateOrderStatus } from '../../../Server/Mutation/index';

import { toLocalPhone } from '../../../Helpers';

/**
 * @param {{data:{
    id: string;
    dateTime: string;
    note: string;
    status: string;
    referenceId: string;
    place: string;
    professional: { fullName: string;mobileNumber: string}
    service:{ name: string;}
    package: { name: string; price: string;};
  }
  updateParentCards?:() => void
}} props
 * @returns {JSX.Element}
 */

function JobInformationCard({ data, updateParentCards }) {
  const { showToastMessage } = useContext(ToastContext);

  async function handleClickCancel() {
    // const response = await Axios({
    //   query: UpdateOrderStatus({
    //     orderUniqueID: data.id,
    //     orderStatus: ORDER_STATUS.CUSTOMER_CANCELLED,
    //   }),
    // });
    // if (response.errors) {
    //   showToastMessage('Something went wrong while trying to cancel the order', 'error');
    //   return undefined;
    // }

    // showToastMessage('Order cancelled successfully', 'success');
    // updateParentCards?.();
  }

  return (
    <CardLayout>
      <Stack gap={2} direction={{ xs: 'column', sm: 'row' }} justifyContent='space-between'>
        <div>
          <TypoPoppBlue variant='body1' fontWeight={600} mb={1.2}>
            {data.professional.fullName}
          </TypoPoppBlue>

          <Box
            display='grid'
            gridTemplateColumns={{ xs: 'auto', md: 'auto 1fr' }}
            rowGap={1}
            columnGap={2}>
            <TypoPoppins>Reference ID</TypoPoppins>
            <TypoPoppins fontWeight={500}>{data.referenceId}</TypoPoppins>

            <TypoPoppins>Contact</TypoPoppins>
            <TypoPoppins fontWeight={500}>{toLocalPhone(data.professional.mobileNumber)}</TypoPoppins>

            <TypoPoppins>Job Title</TypoPoppins>
            <TypoPoppins fontWeight={500}>{data.service.name}</TypoPoppins>

            <TypoPoppins>Service Place</TypoPoppins>
            <TypoPoppins fontWeight={500}>{data.place}</TypoPoppins>

            <TypoPoppins>Event Date</TypoPoppins>
            <TypoPoppins fontWeight={500}>{data.dateTime}</TypoPoppins>

            <TypoPoppins>Package</TypoPoppins>
            <TypoPoppins fontWeight={500}>{data.package.name}</TypoPoppins>

            <TypoPoppins>Price</TypoPoppins>
            <TypoPoppins fontWeight={500}>{data.package.price}</TypoPoppins>

            <TypoPoppins alignSelf='start'>Note</TypoPoppins>
            <TypoPoppins fontWeight={500}>{data.note}</TypoPoppins>
          </Box>
        </div>

        <Stack
          justifyContent='space-between'
          alignItems={{ xs: 'center', sm: 'unset' }}
          flexDirection={{ xs: 'row', sm: 'column' }}>
          <TypoPoppins
            fontWeight={500}
            color={data.status === ORDER_STATUS.REJECTED ? COLORS.red : COLORS.green}>
            {data.status}
          </TypoPoppins>

          {data.status === ORDER_STATUS.ACCEPTED && (
            <Button
              variant='outlined'
              color='blue'
              size='small'
              onClick={handleClickCancel}
              sx={{ ml: 'auto' }}>
              <Typography variant='caption' color={COLORS.blue} sx={{ pointerEvents: 'none' }}>
                Cancel
              </Typography>
            </Button>
          )}
        </Stack>
      </Stack>
    </CardLayout>
  );
}

JobInformationCard.propTypes = {
  updateParentCards: PropTypes.func,
  data: PropTypes.shape({
    id: PropTypes.string.isRequired,
    dateTime: PropTypes.string.isRequired,
    note: PropTypes.string.isRequired,
    status: PropTypes.oneOf(Object.values(ORDER_STATUS)).isRequired,
    referenceId: PropTypes.string.isRequired,
    place: PropTypes.string.isRequired,
    professional: PropTypes.shape({
      fullName: PropTypes.string.isRequired,
      mobileNumber: PropTypes.string.isRequired,
    }).isRequired,
    service: PropTypes.shape({
      name: PropTypes.string.isRequired,
    }).isRequired,
    package: PropTypes.shape({
      name: PropTypes.string.isRequired,
      price: PropTypes.string.isRequired,
    }).isRequired,
  }),
};

export default JobInformationCard;
